import PropTypes from 'prop-types'

export const nodePropTypes = {
  id: PropTypes.string.isRequired,
  data: PropTypes.shape({
    content: PropTypes.any,
    label: PropTypes.string,
    header: PropTypes.string,
    description: PropTypes.string,
    overrideBackgroundColor: PropTypes.bool,
    nodeProps: PropTypes.shape({
      size: PropTypes.oneOf(['sm', 'md', 'lg']),
      handles: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.object])),
      targets: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.object]))
    }),
    entityProps: PropTypes.shape({
      color: PropTypes.string
    }),
    style: PropTypes.object
  }),
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  selected: PropTypes.bool
}
